import React from 'react';
import { ShieldIcon, SparklesIcon, ZapIcon, HeartIcon, SmileIcon, PiggyBankIcon, GiftIcon } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    icon: <ShieldIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-46" />,
    title: 'Sterk Immuunsysteem',
    description: 'Een gezonde darm betekent een krachtig afweersysteem dat je hond beschermt tegen ziektes'
  }, {
    icon: <SparklesIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-47" />,
    title: 'Betere Opname van Voedingsstoffen',
    description: 'Maximale benutting van alle vitamines en mineralen voor optimale gezondheid'
  }, {
    icon: <ZapIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-48" />,
    title: 'Meer Vitaliteit en Energie',
    description: 'Een gezond lichaam heeft meer energie voor spelen, wandelen en genieten'
  }, {
    icon: <HeartIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-49" />,
    title: 'Glanzende Vacht',
    description: 'Van binnenuit verzorgd voor een prachtige, glanzende vacht zonder jeuk'
  }, {
    icon: <SmileIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-50" />,
    title: 'Minder Gezondheids- én Gedragsproblemen',
    description: 'Een gezonde hond is een gelukkige hond met stabiel gedrag'
  }, {
    icon: <PiggyBankIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-51" />,
    title: 'Minder Kosten aan Dierenarts',
    description: 'Preventie bespaart je op lange termijn veel geld en zorgen'
  }];
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-white to-green-50" data-id="element-52">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-53">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[rgb(var(--color-neutral-900))] mb-4 sm:mb-6" data-id="element-54">
          Investeer in Gezondheid, Bespaar op Dierenartskosten
        </h2>

        <p className="text-base sm:text-xl text-center text-[rgb(var(--color-neutral-800))] mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-55">
          Een gezonde darm is het fundament voor een vitaal en gelukkig leven
        </p>

        {/* Discount Announcement Section */}
        <div className="mb-12 sm:mb-16 max-w-4xl mx-auto" data-id="element-56">
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-[rgb(var(--color-secondary))] rounded-2xl p-6 sm:p-8 lg:p-10 shadow-xl" data-id="element-57">
            <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6" data-id="element-58">
              <div className="flex-shrink-0 mx-auto sm:mx-0" data-id="element-59">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[rgb(var(--color-secondary))] to-orange-600 rounded-full flex items-center justify-center shadow-lg" data-id="element-60">
                  <GiftIcon className="w-6 h-6 sm:w-8 sm:h-8 text-white" data-id="element-61" />
                </div>
              </div>
              <div className="flex-1 text-center sm:text-left" data-id="element-62">
                <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[rgb(var(--color-neutral-900))] mb-3 sm:mb-4" data-id="element-63">
                  Een Speciale Start voor U en Uw Hond
                </h3>
                <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed mb-3 sm:mb-4" data-id="element-64">
                  Omdat u de tijd heeft genomen om u te verdiepen in de
                  gezondheid van uw hond, willen we u graag een extra steuntje
                  in de rug geven. Wij geloven dat elke hond de kans verdient op
                  een gezonde start.
                </p>
                <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed font-semibold" data-id="element-65">
                  Daarom ontvangt u, als lezer van deze pagina,{' '}
                  <span className="text-[rgb(var(--color-secondary))]" data-id="element-66">
                    10% welkomstkorting
                  </span>{' '}
                  op uw eerste bestelling. Zo wordt de investering in de
                  toekomst van uw trouwe vriend nog laagdrempeliger.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Grid: 1 column mobile, 2 columns tablet, 3 columns desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12" data-id="element-67">
          {benefits.map((benefit, index) => <div key={index} className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border-t-4 border-[rgb(var(--color-primary))]" data-id="element-68">
              <div className="text-[rgb(var(--color-primary))] mb-4" data-id="element-69">
                {benefit.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[rgb(var(--color-neutral-900))] mb-3 flex items-center gap-2" data-id="element-70">
                <span className="text-xl sm:text-2xl" data-id="element-71">🌟</span>
                {benefit.title}
              </h3>
              <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))] leading-relaxed" data-id="element-72">
                {benefit.description}
              </p>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-2xl p-6 sm:p-8 lg:p-12 shadow-2xl" data-id="element-73">
          <div className="max-w-3xl mx-auto text-center" data-id="element-74">
            <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-3 sm:mb-4" data-id="element-75">
              Investeer Nu, Bespaar Later
            </h3>
            <p className="text-base sm:text-xl leading-relaxed mb-4 sm:mb-6" data-id="element-76">
              Een gezonde hond betekent minder dierenartsbezoeken, minder
              medicatie, en minder gedragstherapie. De investering in
              natuurlijke voeding betaalt zichzelf terug.
            </p>
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 sm:p-6 inline-block" data-id="element-77">
              <p className="text-base sm:text-lg font-semibold mb-2" data-id="element-78">
                Gemiddelde besparingen per jaar:
              </p>
              <div className="flex items-center justify-center gap-3 sm:gap-4 text-2xl sm:text-3xl font-bold" data-id="element-79">
                <span className="line-through opacity-75" data-id="element-80">€500+</span>
                <span data-id="element-81">→</span>
                <span className="text-yellow-300" data-id="element-82">Preventie</span>
              </div>
              <p className="text-xs sm:text-sm mt-2 opacity-90" data-id="element-83">
                Minder dierenarts, minder medicatie, meer gezondheid
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}